import type { ItemType } from '@atlassian/jira-favourite-change-provider/src/model/types.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

type Request = {
	id: string;
	type: ItemType;
};

export const getFavoriteUrl = (request: Request): string =>
	`/rest/internal/2/favourites/${request.type}/${request.id}`;

export const getFavorite = async (request: Request): Promise<boolean> =>
	performGetRequest(getFavoriteUrl(request));
